import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function MyAdminPayments() {
  const [pays, setPays] = useState([]);
  useEffect(() => { api.get("/myadmin/payments").then(r => setPays(r.data.payments)); }, []);
  return (
    <div data-testid="myadmin-payments">
      <header className="mb-6"><p className="eyebrow">MyAdmin</p><h1 className="font-serif-luxe text-4xl mt-3">Paiements <span className="italic gold-text">({pays.length}).</span></h1></header>
      <div className="card-luxe overflow-x-auto">
        <table className="w-full text-sm" data-testid="payments-table">
          <thead><tr className="text-left text-[10px] uppercase tracking-[0.2em] text-white/45 border-b border-[#DCB457]/15">
            <th className="p-3">Date</th><th className="p-3">Événement</th><th className="p-3">Forfait</th><th className="p-3">Montant</th><th className="p-3">Statut</th><th className="p-3">Provider</th>
          </tr></thead>
          <tbody>
            {pays.length === 0 ? (
              <tr><td colSpan={6} className="p-8 text-center text-white/40 italic">Aucun paiement plateforme pour le moment. Stripe TEST sera activé à l'étape suivante.</td></tr>
            ) : pays.map(p => (
              <tr key={p.id} className="border-b border-[#DCB457]/5">
                <td className="p-3 text-white/60 text-xs">{p.created_at && new Date(p.created_at).toLocaleString("fr-FR")}</td>
                <td className="p-3">{p.event_name || "—"}</td>
                <td className="p-3 text-white/60">{p.plan_name || "—"}</td>
                <td className="p-3">{p.amount} {p.currency}</td>
                <td className="p-3"><span className="text-[10px] uppercase tracking-widest border border-[#DCB457]/30 px-2 py-1 text-[#DCB457]">{p.status}</span></td>
                <td className="p-3 text-white/50 text-xs">{p.provider}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
